import React from "react";
import OrbViewButton from "../OrbViewButton/OrbViewButton";
import { Subscribe } from "unstated";
import StateContainer from "../../state/StateContainer";
import stringHelper from "../../utils/helpers/stringHelper";
import { useTranslation } from "react-i18next";

import "./OrbViewSidebar.css";

function OrbViewSidebar(props) {
  const { t } = useTranslation();

  return (
    <div className="orb-sidebar">
      <div
        className="orb-sidebar__top"
        style={{ backgroundColor: props.unstated.state.menuColor }}
      >
        <div
          className="orb-sidebar__top__header"
          style={{
            backgroundColor: stringHelper.removeAplhaFromColor(
              props.unstated.state.menuColor
            ),
          }}
        >
          <p className="orb-sidebar__top__header-text">
            360 &deg; <br /> {t("VIEW")} 
          </p>
        </div>
      </div>
      <div className="orb-sidebar__button-container">
       {props.unstated.state.orbViews?.map((orbView) => <OrbViewButton image={orbView.image} id={orbView.id} />)}
      </div>
    </div>
  );
}

function OrbViewSidebarWithUnstated(props) {
  return (
    <Subscribe to={[StateContainer]}>
      {(unstated) => <OrbViewSidebar {...props} unstated={unstated} />}
    </Subscribe>
  );
}

export default OrbViewSidebarWithUnstated;
